import { useEffect, useState } from "react";
import { Search, X } from "lucide-react";import api from "@/lib/api";
import { GlassCard, SectionLabel } from "@/components/primitives";
import { Users, Building2 } from "lucide-react";

export default function Organization() {
  const [depts, setDepts] = useState([]);
  const [emps, setEmps] = useState([]);
  const [search, setSearch] = useState("");
const [selectedDept, setSelectedDept] = useState("All");
const [selectedEmployee, setSelectedEmployee] = useState(null);
  useEffect(() => {
    api.get("/org/departments").then((r) => setDepts(r.data));
    api.get("/org/employees").then((r) => setEmps(r.data));
  }, []);
  const filteredEmployees = emps.filter((e) => {
  const matchesSearch =
    e.name.toLowerCase().includes(search.toLowerCase()) ||
    e.role.toLowerCase().includes(search.toLowerCase()) ||
    e.department.toLowerCase().includes(search.toLowerCase());

  const matchesDept =
    selectedDept === "All" || e.department === selectedDept;

  return matchesSearch && matchesDept;
});

  return (
    <div className="space-y-5" data-testid="org-page">
      <div>
        <SectionLabel>Organization</SectionLabel>
        <h1 className="mt-1 text-3xl font-bold tracking-tight">Teams, hierarchy & <span className="gradient-text">roles</span></h1>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-4">
        {depts.map((d, i) => (
          <GlassCard key={d.id} className="p-5">
            <div className="flex items-center justify-between"><Building2 className="h-4 w-4 text-cyan-300" /><span className="text-[10px] font-mono text-slate-500">DEPT {String(i + 1).padStart(2, "0")}</span></div>
            <h3 className="mt-2 text-lg font-semibold">{d.name}</h3>
            <div className="text-xs text-slate-400 mt-1">Lead: <span className="text-slate-200">{d.head}</span></div>
            <div className="mt-3 grid grid-cols-2 gap-2 text-center">
              <div className="rounded-lg bg-white/[0.03] border border-white/10 p-2"><div className="text-[10px] font-mono text-slate-500">HEADCOUNT</div><div className="font-mono text-lg">{d.headcount}</div></div>
              <div className="rounded-lg bg-white/[0.03] border border-white/10 p-2"><div className="text-[10px] font-mono text-slate-500">OPEN INC</div><div className="font-mono text-lg text-cyan-300">{d.open_incidents}</div></div>
            </div>
          </GlassCard>
        ))}
      </div>

      <GlassCard className="p-6">
        <div className="flex items-center justify-between">
          <div><SectionLabel>People</SectionLabel><h2 className="mt-1 text-xl font-semibold">All employees</h2></div>
          <span className="text-xs text-slate-400">{emps.length} members</span>
        </div>
        <div className="flex flex-wrap gap-3 mb-5">

  <div className="relative flex-1 min-w-[250px]">
    <Search className="absolute left-3 top-3 h-4 w-4 text-slate-500" />

    <input
      value={search}
      onChange={(e)=>setSearch(e.target.value)}
      placeholder="Search employee..."
      className="w-full rounded-xl bg-white/[0.04] border border-white/10 pl-10 pr-10 py-2 text-sm outline-none focus:border-cyan-400"
    />

    {search && (
      <button
        onClick={()=>setSearch("")}
        className="absolute right-3 top-3"
      >
        <X className="h-4 w-4 text-slate-500"/>
      </button>
    )}
  </div>

  <div className="flex flex-wrap gap-2">

  {["All", ...depts.map(d => d.name)].map(dep => (

    <button
      key={dep}
      onClick={() => setSelectedDept(dep)}
      className={`px-4 py-2 rounded-xl border transition-all
      ${
        selectedDept === dep
          ? "bg-cyan-500 text-white border-cyan-400 shadow-[0_0_20px_rgba(0,240,255,.35)]"
          : "bg-white/[0.03] border-white/10 hover:border-cyan-400"
      }`}
    >
      {dep}
    </button>

  ))}

</div>

</div>
        <div className="mt-4 grid md:grid-cols-2 lg:grid-cols-3 gap-3">
          {filteredEmployees.map((e) => (
            <div
  key={e.id}
  onClick={() => setSelectedEmployee(e)}
  className="cursor-pointer p-4 rounded-2xl bg-white/[0.03] border border-white/10 flex items-center gap-3 transition-all duration-300 hover:border-cyan-400 hover:bg-cyan-500/5 hover:shadow-[0_0_20px_rgba(0,240,255,0.15)]"
>
              <div className="h-10 w-10 rounded-full bg-gradient-to-br from-cyan-400 to-violet-500 grid place-items-center font-bold">{e.name[0]}</div>
              <div className="min-w-0">
                <div className="text-sm font-semibold truncate">{e.name}</div>
                <div className="text-[11px] text-slate-400 truncate">{e.role} · {e.department}</div>
              </div>
            </div>
          ))}
        </div>
            </GlassCard>

      {selectedEmployee && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">

          <div className="w-[650px] max-w-[95%] rounded-3xl bg-[#0F172A] border border-cyan-500/20 p-8 shadow-2xl">

            <div className="flex justify-between">

              <div className="flex gap-4">

                <div className="h-16 w-16 rounded-full bg-gradient-to-br from-cyan-400 to-violet-500 flex items-center justify-center text-2xl font-bold">
                  {selectedEmployee.name[0]}
                </div>

                <div>

                  <h2 className="text-2xl font-bold">
                    {selectedEmployee.name}
                  </h2>

                  <p className="text-cyan-300">
                    {selectedEmployee.role}
                  </p>

                  <p className="text-slate-400">
                    {selectedEmployee.department}
                  </p>

                </div>

              </div>

              <button
                onClick={() => setSelectedEmployee(null)}
              >
                <X />
              </button>

            </div>

            <div className="grid grid-cols-2 gap-4 mt-8">

              <Info title="Email" value={`${selectedEmployee.name.toLowerCase().replace(/ /g,".")}@sentinelai.io`} />

              <Info title="Status" value="Active" />

              <Info title="Experience" value="6 Years" />

              <Info title="Location" value="Remote" />

              <Info title="Manager" value="CTO" />

              <Info title="Employee ID" value={`EMP-${selectedEmployee.id}`} />

            </div>

            <div className="mt-8">

              <h3 className="font-semibold mb-3">
                Skills
              </h3>

              <div className="flex flex-wrap gap-2">

                {[
                  "Python",
                  "Docker",
                  "AWS",
                  "Kubernetes",
                  "Incident Response"
                ].map(skill => (

                  <span
                    key={skill}
                    className="px-3 py-1 rounded-full bg-cyan-500/10 border border-cyan-500/20 text-cyan-300 text-sm"
                  >
                    {skill}
                  </span>

                ))}

              </div>

            </div>

          </div>

        </div>
      )}

    </div>
  );
}
function Info({ title, value }) {
  return (

    <div className="rounded-xl border border-white/10 bg-white/[0.03] p-3">

      <div className="text-xs uppercase text-slate-500">

        {title}

      </div>

      <div className="mt-1 text-white">

        {value}

      </div>

    </div>

  );
}